import { AsyncGridColumns } from '~/shared/ui/AsyncGrid'
import { GridRow } from './types'

export const defaultColumns: AsyncGridColumns<GridRow> = [
  {
    headerName: 'column.field',
    field: 'field',
    sortable: false,
    flex: 1,
  },
  {
    headerName: 'column.old value',
    field: 'old',
    sortable: false,
    flex: 1,
  },
  {
    headerName: 'column.new value',
    field: 'new',
    sortable: false,
    flex: 1,
  },
]

export const balanceTransferColumns: AsyncGridColumns<GridRow> = [
  {
    headerName: 'column.field',
    field: 'field',
    sortable: false,
    flex: 1,
  },
  {
    headerName: 'column.from',
    field: 'old',
    sortable: false,
    flex: 1,
  },
  {
    headerName: 'column.to',
    field: 'new',
    sortable: false,
    flex: 1,
  },
]
